import ApiService from './ApiService';

export default {
  /**
   * Finds marketplace template attributes by key.
   * @param {number} marketplaceId Marketplace ID
   * @param {string} key Template Key
   * @returns {Promise<any>}
   */
  findAttributesByKey(marketplaceId, key) {
    return new Promise((resolve, reject) => {
      const data = {
        key,
        type: 'attribute',
      };
      ApiService.request('GET', `marketplaces/${marketplaceId}/templates`, data).then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject(new Error());
        }
      }).catch(() => {
        reject(new Error());
      });
    });
  },
};
